export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/driver-qr-new-a44253dbeb5a0c0fcbace52a1e6bcb60.png";